import React from 'react'

export default function Attemps() {
  return (
    <div>Attemps</div>
  )
}
